import { useEffect, useState } from 'react';
import { gql, useMutation } from '@apollo/client';

export const REACTIVATE_PROPERTY_MUTATION = gql`
    mutation($id: ID!, $activatedAt: String, $expiresAt: String) {
        updateProperty(id: $id, activatedAt: $activatedAt, expiresAt: $expiresAt) {
            id
            activatedAt
            expiresAt
            activations
        }
    }
`;

const useReactivateProperties = ({ propertyIds = [], onCompleted, onError }) => {
    const [mutation, setMutation] = useState(REACTIVATE_PROPERTY_MUTATION);

    useEffect(() => {
        if (propertyIds.length === 0) {
            return;
        }

        let mutationWorking = 'mutation ($activatedAt: String, $expiresAt: String';
        propertyIds.forEach((id, index) => {
            mutationWorking += `, $id${index}: ID!`;
        });

        mutationWorking += ') {';
        propertyIds.forEach((id, index) => {
            mutationWorking += `
                updateProperty${index}: updateProperty(
                    id: $id${index},
                    activatedAt: $activatedAt,
                    expiresAt: $expiresAt
                ) {
                    id
                    activatedAt
                    expiresAt
                    activations
                }
            `;
        });

        mutationWorking += '}';
        setMutation(
            gql`
                ${mutationWorking}
            `
        );
    }, [propertyIds]);

    return useMutation(mutation, {
        onCompleted,
        onError,
    });
};

export default useReactivateProperties;
